import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { BackButton } from 'web-ui-components/lib/molecules/navigation';
import {
  SectionHeading,
  SubHeading,
} from 'web-ui-components/lib/typography/headings';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { renderAccountDetails } from '../ViewPaymentHistory';
import ViewChildPaymentHistory from './ViewChildPaymentHistory';
import config from '../../../config';
import PrintHelper from 'print-helper-lib';
import envConfig from '../../../../static/config';
import StatusBadgeSME from './StatusBadgeSME';
import { VerticalReviewTable } from 'web-ui-components/lib/layout/tables';
import { StandardBody } from 'web-ui-components/lib/typography/body';

const ViewBacsHistory = ({
  historyDetails,
  statusMsg,
  goBack,
  parentPayment = false,
}) => {
  const {
    type,
    authorisedBy,
    createdBy,
    status,
    settlement_date,
    submission_date,
    amount,
    bacsId,
    fromAccountAccountNumber,
    fromAccountSortCode,
    fromAccountName,
    toAccountAccountNumber,
    toAccountSortCode,
    toAccountName,
    hmrcReference,
    reference,
    transactionCode,
  } = historyDetails;

  const statusData = [
    {
      headerText: 'Status',
      cellText: (
        <div>
          <StatusBadgeSME status={status} />
          <StandardBody>
            <p>{statusMsg}</p>
          </StandardBody>
        </div>
      ),
    },
  ];

  const paymentData = [
    {
      headerText: 'Type',
      cellText: type === 'BCR' ? 'Bacs Credit' : 'Bacs Debit',
    },
    {
      headerText: 'From',
      cellText: renderAccountDetails(
        fromAccountAccountNumber,
        fromAccountSortCode,
        fromAccountName
      ),
    },
    {
      headerText: 'To',
      cellText: renderAccountDetails(
        toAccountAccountNumber,
        toAccountSortCode,
        toAccountName
      ),
    },
    { headerText: parentPayment ? 'Total Amount' : 'Amount', cellText: amount },
    { ...(reference && { headerText: 'Reference', cellText: reference }) },
    {
      ...(hmrcReference && {
        headerText: 'HMRC Reference',
        cellText: hmrcReference,
      }),
    },
    {
      ...(transactionCode && {
        headerText: 'Transaction Code',
        cellText: transactionCode,
      }),
    },
    { headerText: 'BACS Id', cellText: bacsId },
    {
      headerText: 'Submission Date',
      cellText: moment(submission_date).format(config.dateFormatTimeline),
    },
    {
      headerText: type === 'BCR' ? 'Settlement Date' : 'Collection Date',
      cellText: moment(settlement_date).format(config.dateFormatTimeline),
    },
    { ...(createdBy ? { headerText: 'Created by', cellText: createdBy } : []) },
    {
      ...(authorisedBy && {
        headerText: 'Authorised by',
        cellText: authorisedBy,
      }),
    },
  ];

  const filteredPaymentData = paymentData.filter(
    (row) => Object.keys(row).length !== 0
  );

  return (
    <div className="web-ui-components">
      <BackButton onClick={goBack} />
      <SubHeading>Payment Detail</SubHeading>
      <div className="u-component-spacing">
        <div className="u-margin-bottom-4">
          <SectionHeading>Bank acknowledgement details</SectionHeading>
          <PrintHelper
            className="web-ui-components"
            brandId={envConfig.brandId}
            showPrintTopIcon
            showPrintBottomIcon={false}
          />
          <VerticalReviewTable data={statusData} />
        </div>
        <div className="u-margin-bottom-2">
          <SectionHeading heading3={'Your payment details'} />
          <VerticalReviewTable data={filteredPaymentData} />
        </div>

        {parentPayment && historyDetails.children && (
          <ViewChildPaymentHistory historyDetails={historyDetails} />
        )}

        <NavigationButton.Secondary labelText="Back" onClick={goBack} />
      </div>
    </div>
  );
};

ViewBacsHistory.propTypes = {
  statusMsg: PropTypes.string.isRequired,
  historyDetails: PropTypes.shape({
    type: PropTypes.string.isRequired,
    authorisedBy: PropTypes.string.isRequired,
    createdBy: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    settlement_date: PropTypes.string.isRequired,
    submission_date: PropTypes.string.isRequired,
    amount: PropTypes.string.isRequired,
    bacsId: PropTypes.string.isRequired,
    fromAccountAccountNumber: PropTypes.string.isRequired,
    fromAccountSortCode: PropTypes.string.isRequired,
    fromAccountName: PropTypes.string.isRequired,
    toAccountAccountNumber: PropTypes.string.isRequired,
    toAccountSortCode: PropTypes.string.isRequired,
    toAccountName: PropTypes.string.isRequired,
    hmrcReference: PropTypes.string,
    reference: PropTypes.string.isRequired,
    transactionCode: PropTypes.string,
  }).isRequired,
  goBack: PropTypes.func.isRequired,
  parentPayment: PropTypes.bool,
};

export default ViewBacsHistory;
